import { create } from 'zustand';

/**
 * Confirm dialog state for an undo that will also discard later work.
 *
 * Undoing a tool in the middle of a step cannot leave the tools applied after it
 * standing — they were computed against geometry that is about to be replaced.
 * Both the live-command path (`resetHistoryUpTo` truncates history) and the
 * stored-socket path drop them, so the user has to be told before it happens.
 *
 * Mirrors `useBackwardNavigationStore`: a single pending request, resolved by the
 * dialog calling back into the confirm/cancel handlers held on it.
 *
 * @typedef {Object} PendingUndoConfirm
 * @property {string} toolId
 * @property {string} toolName
 * @property {string[]} alsoUndoneNames  Display names of the tools that go too.
 * @property {() => void} onConfirm
 * @property {() => void} [onCancel]
 */
const useUndoConfirmStore = create((set) => ({
  /** @type {PendingUndoConfirm | null} */
  pending: null,
  setPending: (pending) => set({ pending }),
  clearPending: () => set({ pending: null }),
}));

export default useUndoConfirmStore;
